import React, { useEffect, useState } from 'react'
import { findPathUrl, ROUTE_PATH } from './../../helpers'
import PropTypes from 'prop-types'
import {
  companyProfile,
  userManagement,
  userDetailFormBuyer,
  userEditFormBuyer,
  supplierManagementBuyer,
  uploadSupplierFormBuyer,
  editSupplier,
  supplierDiscovery,
  supplierInformation,
  riskManagement,
  regulatory,
  sustainaBility,
  comprehensiveAssessment,
  sourcingProjects,
  sourcingProjectsCreateEvent,
  sourcingEvent,
  sourcingEventEdit,
  sourcingEventsEdit,
  sourcingDetailFormEdit,
  sourcingProjectDetail,
  sourcingCreateNewRound,
  sourcingCompareEvents,
  sourcingCompareEvent,
} from './linkList'
import { funcRenderLink } from './funcRenderLink'
import { isEmpty } from 'lodash'
const Breadcrumbs = ({ props }) => {
  const { match } = props
  const { params } = match
  const [linkBreadcrumbs, setLinkBreadcrumbs] = useState([])
  const objUrlSourcingCompareEvent = findPathUrl(
    ROUTE_PATH.SOURCING_COMPARE_EVENT.LINK,
    props
  )
  const urlSourcingCompareEvent = !isEmpty(objUrlSourcingCompareEvent)
    ? objUrlSourcingCompareEvent.url
    : ''
  const objUrlSourcingCompareEvents = findPathUrl(
    ROUTE_PATH.SOURCING_COMPARE_EVENTS.LINK,
    props
  )
  const urlSourcingCompareEvents = !isEmpty(objUrlSourcingCompareEvents)
    ? objUrlSourcingCompareEvents.url
    : ''
  const objUrlCompanyprofile = findPathUrl(
    ROUTE_PATH.COMPANY_PROFILE_FORM_BUYER.LINK,
    props
  )
  const urlCompanyprofile = !isEmpty(objUrlCompanyprofile)
    ? objUrlCompanyprofile.url
    : ''
  const objUrlCreateNewRound = findPathUrl(
    ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_COPYCREATE.LINK,
    props
  )
  const urlCreateNewRound = !isEmpty(objUrlCreateNewRound)
    ? objUrlCreateNewRound.url
    : ''
  const objUrlUserManagementBuyer = findPathUrl(
    ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK,
    props
  )
  const urlUserManagementBuyer = !isEmpty(objUrlUserManagementBuyer)
    ? objUrlUserManagementBuyer.url
    : ''
  const objUrlUserDetailFormBuyer = findPathUrl(
    ROUTE_PATH.USER_DETAIL_FORM_BUYER.LINK,
    props
  )
  const urlUserDetailFormBuyer = !isEmpty(objUrlUserDetailFormBuyer)
    ? objUrlUserDetailFormBuyer.url
    : ''
  const objUrlSupplierManagementBuyer = findPathUrl(
    ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK,
    props
  )
  const urlSupplierManagementBuyer = !isEmpty(objUrlSupplierManagementBuyer)
    ? objUrlSupplierManagementBuyer.url
    : ''
  const objUrlUploadSupplierFormBuyer = findPathUrl(
    ROUTE_PATH.UPLOAD_SUPPLIER_FORM_BUYER.LINK,
    props
  )
  const urlUploadSupplierFormBuyer = !isEmpty(objUrlUploadSupplierFormBuyer)
    ? objUrlUploadSupplierFormBuyer.url
    : ''
  const objUrlSupplierDiscovery = findPathUrl(
    ROUTE_PATH.SUPPLIER_DISCOVERY.LINK,
    props
  )
  const urlSupplierDiscovery = !isEmpty(objUrlSupplierDiscovery)
    ? objUrlSupplierDiscovery.url
    : ''
  const objUrlRiskManagement = findPathUrl(
    ROUTE_PATH.RISK_MANAGEMENT.LINK,
    props
  )
  const urlRiskManagement = !isEmpty(objUrlRiskManagement)
    ? objUrlRiskManagement.url
    : ''
  const objUrlUploadRegulatory = findPathUrl(
    ROUTE_PATH.UPLOAD_REGULATORY.LINK,
    props
  )
  const urlUploadRegulatory = !isEmpty(objUrlUploadRegulatory)
    ? objUrlUploadRegulatory.url
    : ''
  const objUrlUploadSustainaBility = findPathUrl(
    ROUTE_PATH.UPLOAD_SUSTAINABILITY_BUYER.LINK,
    props
  )
  const urlUploadSustainaBility = !isEmpty(objUrlUploadSustainaBility)
    ? objUrlUploadSustainaBility.url
    : ''
  const objUrlComprehensiveAssessment = findPathUrl(
    ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK,
    props
  )
  const urlComprehensiveAssessment = !isEmpty(objUrlComprehensiveAssessment)
    ? objUrlComprehensiveAssessment.url
    : ''
  const objUrlSourcingProjects = findPathUrl(
    ROUTE_PATH.SOURCING_PROJECTS.LINK,
    props
  )
  const urlSourcingProjects = !isEmpty(objUrlSourcingProjects)
    ? objUrlSourcingProjects.url
    : ''
  const objUrlCreateSourcingDetailForm = findPathUrl(
    ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM.LINK,
    props
  )
  const urlCreateSourcingDetailForm = !isEmpty(objUrlCreateSourcingDetailForm)
    ? objUrlCreateSourcingDetailForm.url
    : ''
  const objUrlSourcingBuyerEvent = findPathUrl(
    ROUTE_PATH.SOURCING_BUYER.LINK,
    props
  )
  const urlSourcingBuyerEvent = !isEmpty(objUrlSourcingBuyerEvent)
    ? objUrlSourcingBuyerEvent.url
    : ''
  const objUrlIdUserEdit = findPathUrl(
    ROUTE_PATH.USER_EDIT_FORM_BUYER.LINK,
    props
  )
  const objUrlEditSupplier = findPathUrl(
    ROUTE_PATH.SUPPLIER_MANAGEMENT_INFORMATION_EDIT.LINK,
    props
  )
  const objUrlSupplierInformation = findPathUrl(
    ROUTE_PATH.SUPPLIER_DISCOVERY_INFORMATION.LINK,
    props
  )
  const objUrlSourcingDetailForm = findPathUrl(
    ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EDIT.LINK,
    props
  )
  const objUrlDetailFormEventEdit = findPathUrl(
    ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EVENT_EDIT.LINK,
    props
  )
  const objUrlDetailFormEventsEdit = findPathUrl(
    ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EVENTS_EDIT.LINK,
    props
  )
  const objUrlSourcingDetailFormEdit = findPathUrl(
    ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_COPYCREATE_EDIT.LINK,
    props
  )
  const objUrlSourcingProjectDetail = findPathUrl(
    ROUTE_PATH.SOURCING_PROJECT_DETAIL.LINK,
    props
  )
  const urlIdUserEdit = !isEmpty(objUrlIdUserEdit) ? objUrlIdUserEdit.url : ''
  const urlEditSupplier = !isEmpty(objUrlEditSupplier)
    ? objUrlEditSupplier.url
    : ''
  const urlSupplierInformation = !isEmpty(objUrlSupplierInformation)
    ? objUrlSupplierInformation.url
    : ''
  const urlSourcingDetailForm = !isEmpty(objUrlSourcingDetailForm)
    ? objUrlSourcingDetailForm.url
    : ''
  const urlDetailFormEventEdit = !isEmpty(objUrlDetailFormEventEdit)
    ? objUrlDetailFormEventEdit.url
    : ''
  const urlDetailFormEventsEdit = !isEmpty(objUrlDetailFormEventsEdit)
    ? objUrlDetailFormEventsEdit.url
    : ''
  const urlSourcingProjectDetail = !isEmpty(objUrlSourcingProjectDetail)
    ? objUrlSourcingProjectDetail.url
    : ''
  const urlSourcingDetailFormEdit = !isEmpty(objUrlSourcingDetailFormEdit)
    ? objUrlSourcingDetailFormEdit.url
    : ''
  const funcMatchUrl = props => {
    if (props) {
      const { match } = props
      if (match) {
        switch (match.url) {
          case urlCompanyprofile: {
            return setLinkBreadcrumbs(companyProfile)
          }
          case urlUserManagementBuyer: {
            return setLinkBreadcrumbs(userManagement)
          }
          case urlUserDetailFormBuyer: {
            return setLinkBreadcrumbs(userDetailFormBuyer)
          }
          case urlIdUserEdit: {
            return setLinkBreadcrumbs(userEditFormBuyer)
          }
          case urlSupplierManagementBuyer: {
            return setLinkBreadcrumbs(supplierManagementBuyer)
          }
          case urlUploadSupplierFormBuyer: {
            return setLinkBreadcrumbs(uploadSupplierFormBuyer)
          }
          case urlEditSupplier: {
            return setLinkBreadcrumbs(editSupplier)
          }
          case urlSupplierDiscovery: {
            return setLinkBreadcrumbs(supplierDiscovery)
          }
          case urlSupplierInformation: {
            return setLinkBreadcrumbs(supplierInformation)
          }
          case urlRiskManagement: {
            return setLinkBreadcrumbs(riskManagement)
          }
          case urlUploadRegulatory: {
            return setLinkBreadcrumbs(regulatory)
          }
          case urlUploadSustainaBility: {
            return setLinkBreadcrumbs(sustainaBility)
          }
          case urlComprehensiveAssessment: {
            return setLinkBreadcrumbs(comprehensiveAssessment)
          }
          case urlSourcingProjects: {
            return setLinkBreadcrumbs(sourcingProjects)
          }
          case urlSourcingDetailForm: {
            return setLinkBreadcrumbs(sourcingProjectsCreateEvent)
          }
          case urlCreateSourcingDetailForm: {
            return setLinkBreadcrumbs(sourcingProjectsCreateEvent)
          }
          case urlSourcingBuyerEvent: {
            return setLinkBreadcrumbs(sourcingEvent)
          }
          case urlDetailFormEventEdit: {
            return setLinkBreadcrumbs(sourcingEventEdit)
          }
          case urlDetailFormEventsEdit: {
            return setLinkBreadcrumbs(sourcingEventsEdit)
          }
          case urlSourcingDetailFormEdit: {
            return setLinkBreadcrumbs(sourcingDetailFormEdit)
          }
          case urlSourcingProjectDetail: {
            return setLinkBreadcrumbs(sourcingProjectDetail)
          }
          case urlCreateNewRound: {
            return setLinkBreadcrumbs(sourcingCreateNewRound)
          }
          case urlSourcingCompareEvents: {
            return setLinkBreadcrumbs(sourcingCompareEvents)
          }
          case urlSourcingCompareEvent: {
            return setLinkBreadcrumbs(sourcingCompareEvent)
          }
          default:
            setLinkBreadcrumbs([])
            break
        }
      }
    }
  }
  useEffect(() => {
    let mounted = true
    if (mounted) {
      return funcMatchUrl(props)
    }
    return () => {
      mounted = false
    }
  }, [])
  const renderLinkBreadcrumbs = () => {
    const link = funcRenderLink(linkBreadcrumbs)
    if (props) {
      const { match } = props
      if (match) {
        switch (match.url) {
          case urlCompanyprofile: {
            return link.renderCompanyprofile()
          }
          case urlUserManagementBuyer: {
            return link.renderUserManagementBuyer()
          }
          case urlUserDetailFormBuyer: {
            return link.renderUserDetail()
          }
          case urlIdUserEdit: {
            return link.renderUserEditForm()
          }
          case urlSupplierManagementBuyer: {
            return link.renderSupplierManagementBuyer()
          }
          case urlUploadSupplierFormBuyer: {
            return link.renderUploadSupplier()
          }
          case urlEditSupplier: {
            return link.renderSupplierManagementEdit(urlEditSupplier)
          }
          case urlSupplierDiscovery: {
            return link.renderSupplierDiscovery(urlSupplierDiscovery)
          }
          case urlSupplierInformation: {
            return link.renderSupplierInformation()
          }
          case urlRiskManagement: {
            return link.renderRiskManagement()
          }
          case urlUploadRegulatory: {
            return link.renderUploadRegulatory()
          }
          case urlUploadSustainaBility: {
            return link.renderSustainaBility()
          }
          case urlComprehensiveAssessment: {
            return link.renderComprehensiveAssessment()
          }
          case urlSourcingProjects: {
            return link.renderSourcingProjects()
          }
          case urlSourcingDetailForm: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
            }
            return link.renderCreateEvent(objUrl)
          }
          case urlCreateSourcingDetailForm: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
            }
            return link.renderCreateEvent(objUrl)
          }
          case urlSourcingBuyerEvent: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
            }
            return link.renderSourcingEvent(objUrl)
          }
          case urlDetailFormEventEdit: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
              urlSourcingEvent: '/sourcing-buyer',
            }
            return link.renderSourcingEventEdit(objUrl)
          }
          case urlDetailFormEventsEdit: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
              urlProjectDetails: `/sourcing-project-detail/${params.id}`,
            }
            return link.renderSourcingEventsEdit(objUrl)
          }
          case urlSourcingProjectDetail: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
            }
            return link.renderSourcingProjectDetail(objUrl)
          }
          case urlSourcingDetailFormEdit: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
              urlProjectDetails: `/sourcing-project-detail/${params.id}`,
            }
            return link.renderSourcingDetailFormEdit(objUrl)
          }
          case urlCreateNewRound: {
            const objUrl = {
              urlSourcingProjects: '/sourcing-projects',
              urlProjectDetails: `/sourcing-project-detail/${params.idproject}`,
              urlSourcingEvent: `/sourcing-buyer`,
            }
            return link.renderCreateNewRound(objUrl)
          }
          case urlSourcingCompareEvents: {
            const objUrl = {
              urlProjectDetails: `/sourcing-project-detail/${params.id}`,
              urlSourcingProjects: '/sourcing-projects',
            }
            return link.renderCompareEvents(objUrl)
          }
          case urlSourcingCompareEvent: {
            const objUrl = {
              urlSourcingEvent: '/sourcing-buyer',
            }
            return link.renderCompareEvent(objUrl)
          }
          default:
            return ''
        }
      }
    }
  }
  return renderLinkBreadcrumbs()
}
Breadcrumbs.propTypes = {
  props: PropTypes.object.isRequired,
}
export default Breadcrumbs
